module.exports = __webpack_public_path__ + "img/platform_logo_b5b570cab.png";